import React from 'react';
import PATHES from 'src/constants/pathes';

import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppSelector } from 'src/redux/hooks';
import { loadFromCookies } from 'src/libs/utils';

const PrivateRoute: React.FC = () => {
  const { userInfo } = useAppSelector(state => state.authSlice);
  const accessToken = loadFromCookies('access_token', true);
  const location = useLocation();

  if (!!userInfo?.fullName && accessToken) {
    return <Outlet />;
  }

  return (
    <Navigate
      to={PATHES['LOGIN_PAGE']}
      state={{ from: `${location.pathname}${location.search}${location.hash}` }}
      replace
    />
  );
};

export default PrivateRoute;
